import {
  playerCompatabilityErrorCodes,
  getPlanTitleText
} from 'src/utils/VideoPlayerUtils/Utils';

type SingleMessagePopupProps = {
  playerRef: any;
  popupProps: any;
};

const SingleMessagePopup = ({
  playerRef,
  popupProps
}: SingleMessagePopupProps) => {
  const { messages = {} } = window.translationsAndConfigs || {};
  let error_code = '';
  let error_msg = '';
  let playerErrorMessage = '';
  if (popupProps.error_code) {
    error_code = popupProps.error_code;
  }
  if (popupProps.error_msg) {
    error_msg = popupProps.error_msg;
  }
  if (
    error_code === playerCompatabilityErrorCodes.PLATFORM_NOT_SUPPORTED_MWEB
  ) {
    playerErrorMessage = error_msg || '';
  } else if (
    error_code === playerCompatabilityErrorCodes.PLAYBACK_SESSION_ERROR
  ) {
    playerErrorMessage = messages.Player_Error_PlaybackSessionExpired;
  } else if (
    error_code.toString() ===
    playerCompatabilityErrorCodes.PLAYBACK_RESTRICTED_CODE
  ) {
    playerErrorMessage = messages.Player_Error_PlaybackRestrictedContactUs;
  } else if (
    error_code.toString() ===
    playerCompatabilityErrorCodes.TVOD_DEVICE_LIMIT_CODE
  ) {
    playerErrorMessage = error_msg;
  } else if (
    error_code === playerCompatabilityErrorCodes.CONTENT_NOT_AVAILABLE
  ) {
    playerErrorMessage = error_msg;
  } else if (
    error_code.toString() ===
    playerCompatabilityErrorCodes.PLAYBACK_ERROR_RELOAD
  ) {
    playerErrorMessage = messages.Player_Msg_ProblemPlayingReload_Page;
  } else if (
    error_code.toString() ===
    playerCompatabilityErrorCodes.CONCURRENT_STREAM_LIMIT
  ) {
    playerErrorMessage = messages.Max_Concurrency_Msg;
  } else if (
    error_code.toString() === playerCompatabilityErrorCodes.PLAN_INCOMPATIBLE &&
    popupProps.userData
  ) {
    playerErrorMessage = getPlanTitleText(
      messages.Upgrade_mobileonly_playertext,
      popupProps.userData
    );
  } else if (error_msg !== '') {
    playerErrorMessage = error_msg;
  } else {
    playerErrorMessage = messages.Player_Msg_DRMError_ProblemPlayingContent;
  }
  return (
    <div className="adult-content-error-msg">
      <div className="adult-content-error-text">
        <span>{playerErrorMessage}</span>
      </div>
    </div>
  );
};

export default SingleMessagePopup;
